import { v4 as uuidv4 } from 'uuid';


class AnalyticsSettings{
  constructor() {
    this.analyticsObject = {}
    this.setUserID();
    this.setSessionID();
    this.setUserAgent();
    this.setIpAddress();
  }
  getUserID () {
    if (!this.analyticsObject.userID)
      this.setUserID();
    return this.analyticsObject.userID;
  }

  getAnalyticsSettings() {
    return this.analyticsObject;
  }

  generateID(value) {
    return (+new Date).toString(36).slice(value * -1);
  }

  setUserID() {
    if (localStorage.getItem("userID"))
      this.analyticsObject.userID = localStorage.getItem("userID");
    this.analyticsObject.userID = this.generateID(6);
    localStorage.setItem("userID", this.analyticsObject.userID);
  }

  setSessionID(){
    this.analyticsObject.sessionID = uuidv4();
  }

  setUserAgent(){
    this.analyticsObject.userAgent = navigator.userAgent;
  }

  setIpAddress(){
    this.getIpAddress().then(r => {
      this.analyticsObject.ipaddress = r;
    });
  }

  async getIpAddress(){
    try {
      let response = await fetch(`${BACKEND_HOST}/ip`);
      let ipObj =  await response.json();
      return ipObj.ip;
    }
    catch (err){
      throw new Error("Failed to fetch IP address");
    }
  }
}

export default AnalyticsSettings;



// WEBPACK FOOTER //
// ./src/modules/analyticsLibrary/AnalyticsSettings.js